import { Component, OnInit, AfterViewInit } from '@angular/core';
// import { Options, LabelType } from 'ng5-slider';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { VehicleListService } from 'src/app/services/vehiclelist.service';
import { LookupService } from 'src/app/services/lookup.service';
import { AlertService } from 'src/app/services/alert.service';
import { SearchModel } from 'src/app/models/search';
import { first } from 'rxjs/operators';
import { MatExpansionModule } from '@angular/material/expansion';
import { Global } from 'src/app/shared/global';
declare var $: any;

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit,AfterViewInit {
  minValue: number = 1000;
  maxValue: number = 5000;
  // options: Options = {
  //   floor: 0,
  //   ceil: 100000,
  //   translate: (value: number, label: LabelType): string => {
  //     switch (label) {
  //       case LabelType.Low:
  //         return '<b>Min:</b> $' + value;
  //       case LabelType.High:
  //         return '<b>Max:</b> $' + value;
  //       default:
  //         return '$' + value;
  //     }
  //   }
  // };
  currentUser: any;
  panelOpenState = false;
  isLoggedIn: boolean = false;
  
  searchForm: FormGroup;
  loading = false;
  submitted = false;
  MakeList: any[];
  ModelList: any[];
  StateList: any[];
  ColorList: any[];
  YearList: any[];
  EnterpriseList: any[];
  YearToList: any[];
  imageLoader = true;
  loaderImageUrl: any = Global.LoaderImageUrl;
  noImageUrl: any = Global.NoImageUrl;
  auctionSummaryList:any[];
  constructor(private formBuilder: FormBuilder,
    private router: Router,
    private authenticationService: AuthenticationService,
    private lookupService: LookupService,
    private alertService: AlertService) { 
      
    this.authenticationService.currentUser.subscribe(x => {
      this.currentUser = x;
      if (!this.currentUser) {
        this.isLoggedIn = false;
      }
      else {
        this.isLoggedIn = true;
      }
    });
    }

  ngOnInit(): void {
    this.createForm();
    this.LoadEnterprise();
    this.LoadYear();
    this.LoadMake();
    this.LoadColor();
    // Commented for prod only.
    this.LoadAuctionSummary();
    // $(document).ready(function () {
    //   console.log("Hello from jQuery!");
    // });
  }
  ngAfterViewInit(): void {
      let el = document.querySelector('.toptoscroll');
      el.scrollIntoView({behavior:"smooth"});
    //window.scrollTo(20, document.body.scrollHeight || document.documentElement.scrollHeight);
  }
  get f() { return this.searchForm.controls; }

  createForm() {
    this.searchForm = this.formBuilder.group({
      enterprise: ['', Validators.required],
      yearFrom: [''],
      yearTo: [''],
      make: [''],
      model: [''],
      color: [''],
      //auctionEndDate: [''],
      // priceRange: ['']
    });
  }

  onSubmit() {
    this.submitted = true;
    // reset alerts on submit
    this.alertService.clear();
    // stop here if form is invalid
    if (this.searchForm.invalid) {
      this.alertService.error('Please select seach by seller');
      return;
    }

    let searchModel: SearchModel = new SearchModel();
    let enterprise = this.f.enterprise.value;
    searchModel.enterprise = enterprise.EnterpriseId;

    let yearFrom = this.f.yearFrom.value;
    if (yearFrom) {
      searchModel.yearFrom = yearFrom.YearName;
    }
    else {
      searchModel.yearFrom = yearFrom;
    }

    let yearTo = this.f.yearTo.value;
    if (yearTo) {
      searchModel.yearTo = yearTo.YearName;
    }
    else {
      searchModel.yearTo = yearTo;
    }

    let make = this.f.make.value;
    if (make) {
      searchModel.make = make.MakeId;
    }
    else {
      searchModel.make = make;
    }

    let model = this.f.model.value;
    if (model) {
      searchModel.model = model.ModelId;
    }
    else {
      searchModel.model = model;
    }

    let color = this.f.color.value;
    if (color) {
      searchModel.color = color.ColorId;
    }
    else {
      searchModel.color = color;
    }

    searchModel.style = '';
    searchModel.auctionDateId = '';
    searchModel.iscurrentAuction = '';
    // console.log(searchModel);
    this.router.navigate(['searchdetails'], {
      state: {
        enterpriseId: searchModel.enterprise,
        makeId: searchModel.make,
        modelId: searchModel.model,
        styleId: searchModel.style,
        colorId: searchModel.color,
        fromYear: searchModel.yearFrom,
        toYear: searchModel.yearTo,
        adateId: searchModel.auctionDateId,
        iscurrent: searchModel.iscurrentAuction
      }
    });
  }

  onReset() {
    Object.keys(this.searchForm.controls).forEach(field => {
      const control = this.searchForm.get(field);
      if (control instanceof FormControl) {
        control.setValue("");
      }
    }); 
    this.onSubmit();
  }

  // navigate() {
  //   this.router.navigate(['probarborrar'], {
  //     queryParams: {
  //       id: '123' //pass whatever here
  //     }
  //   });
  // }

  // navigateByUrl() {
  //   const url = '/probarborrar?id=33';
  //   this.router.navigateByUrl(url);
  // }

  LoadMake() {
    this.MakeList = [];
    this.lookupService.getMakes().subscribe(res => {
      this.MakeList = res;
    },
      (error) => {
        console.log(error);
      });
  }

  LoadModel() {
    this.ModelList = [];
    let makeId: number = 0;
    let makeDetails: any = (this.searchForm.controls['make']).value;
    if (makeDetails) {
      makeId = makeDetails.MakeId;
    }

    this.lookupService.getModels(makeId).subscribe(res => {
      this.ModelList = res;
    },
      (error) => {
        console.log(error);
      });
  }

  LoadColor() {
    this.ColorList = [];
    this.lookupService.getColors().subscribe(res => {
      this.ColorList = res;
    },
      (error) => {
        console.log(error);
      });
  }

  LoadYear() {
    this.YearList = [];
    this.lookupService.getYears().subscribe(res => {
      this.YearList = res;
      this.YearList.reverse();
    },
      (error) => {
        console.log(error);
      });
  }

  onMakeChange() {
    this.LoadModel();
  }

  LoadEnterprise() {
    this.EnterpriseList = [];
    this.lookupService.getEnterprise().subscribe(res => {
      this.EnterpriseList = res;
      //Default Selection
      // if (this.EnterpriseList.length == 1) {
      //   this.f.enterprise.setValue(this.EnterpriseList[0]);
      // }
    },
      (error) => {
        console.log(error);
      });
  }

  onYearChange(ev) {
    let yearFrom = this.f.yearFrom.value;
    let yearToList = [];
    this.YearList.forEach(x => {
      if (yearFrom.YearName < x.YearName) {
        yearToList.push(x);
      }
    });
    this.YearToList = yearToList;
  }

  LoadAuctionSummary() {
    this.alertService.clear();
    this.loading = true;
    this.lookupService.GetAuctionSummary()
      .subscribe(data => {
        if (data) {
          this.auctionSummaryList = data;
          console.log(this.auctionSummaryList);
          if (this.auctionSummaryList.length > 0) {            
            // this.getIP(); x.TowingId 1346927

            // Pagination

          }
          this.loading = false;
        } else {
          this.auctionSummaryList = [];
          this.alertService.showError('No Result Found');
          this.loading = false;
        }
      },
      error => {
        this.alertService.showError(error);
        this.loading = false;
      });
  }

  navigate(path) {
    this.router.navigate([path], {     
    });
  }
  navigateWithMake(item, IsCurrent: boolean) {
    this.router.navigate(['allauctions'], {
      queryParams: {
        eid: item.EnterpriseId,
        mid: item.MakeId,
        iscurrent: IsCurrent
      }
    });
  }
  setClassFutureAuctionTab(item) {
    if (item.EnterpriseDetails.CurrentAuctionCount <=0 && item.EnterpriseDetails.FutureAuctionCount > 0) {
      return 'tab-pane fade active show';
    }
    else {
      return 'tab-pane fade';
    }
  }

  setClassCurrentAuctionTab(item) {
    if (item.EnterpriseDetails.CurrentAuctionCount > 0 ) {
      return 'tab-pane fade active show';
    }
    else {
      return 'tab-pane fade';
    }
  }

  setClassFutureAuctionLink(item) {
    if (item.EnterpriseDetails.CurrentAuctionCount <=0 && item.EnterpriseDetails.FutureAuctionCount > 0) {
      return 'nav-link active show';
    }
    else {
      return 'nav-link';
    }
  }
  
  setClassCurrentAuctionLink(item) {
    if (item.EnterpriseDetails.CurrentAuctionCount > 0 ) {
      return 'nav-link active show';
    }
    else {
      return 'nav-link';
    }
  }

}
